import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataSeriesItemDataValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'array',
            empty: false,
            mandatory: false
        };
    }
}
